import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { KycVietnamPage } from "./legal.kyc-vietnam";

export const Route = createFileRoute("/vi/legal/kyc-vietnam")({
  head: () => ({
    meta: [{ title: "KYC & Xác minh (Việt Nam) — Banana Cards" }],
    links: alternateLinkList("/legal/kyc-vietnam", "vi"),
  }),
  component: KycVietnamPage,
});